Vue.component('urlshortener-debug', require('./GtmTracking/Tests/vue/urlshortener-debug.vue').default);
